import Button from '@mui/material/Button';

import { ListItem } from 'reservations/base/components/ListItem';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  useBookingChecklessPayment,
  useBookingPaymentMethod,
  useIsBillSplit,
  useIsLead,
  useNumberOfGuests,
  useNumberOfGuestsInvitedToSplit,
  useNumberOfGuestsSplitting
} from 'reservations/booking/providers/BookingProvider';

export const ChecklessEnrollmentDetailsV2 = () => {
  const { cardType, cardLast4 } = useBookingPaymentMethod();
  const { tipPercentage } = useBookingChecklessPayment();
  const { open } = useModal();
  const isLead = useIsLead();
  const numberOfGuests = useNumberOfGuests();
  const numberOfGuestsSplitting = useNumberOfGuestsSplitting();
  const numberOfGuestsInvitedToSplit = useNumberOfGuestsInvitedToSplit();
  const isBillSplit = useIsBillSplit();

  return (
    <>
      {isBillSplit && (
        <ListItem
          primaryLabel="Split the bill"
          secondaryLabel={`Even\u00A0\u00A0•\u00A0\u00A0${numberOfGuestsSplitting} of ${numberOfGuestsInvitedToSplit} enrolled`}
          onClick={() =>
            isLead
              ? open(ModalType.ManageSplitBill, { primaryButtonLabel: 'SAVE' })
              : open(ModalType.ViewSplitBill)
          }
        />
      )}
      <ListItem
        primaryLabel="Payment method"
        secondaryLabel={`${cardType} ${cardLast4}`}
        onClick={() => open(ModalType.UpdateCard)}
      />
      <ListItem
        primaryLabel="Gratuity"
        secondaryLabel={`${tipPercentage}%`}
        onClick={() => open(ModalType.SelectGratuity)}
        includeDivider={false}
      />
      {!isBillSplit && isLead && (
        <Button
          onClick={() =>
            numberOfGuests > 1
              ? open(ModalType.ManageSplitBill, {
                  primaryButtonLabel: 'INVITE TO SPLIT'
                })
              : open(ModalType.InviteToSplit)
          }
        >
          Split the bill
        </Button>
      )}
    </>
  );
};
